/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateWorkspaceMembershipSchema
 */
export interface UpdateWorkspaceMembershipSchema {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWorkspaceMembershipSchema
     */
    isAdmin: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkspaceMembershipSchema
     */
    creditLimit: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkspaceMembershipSchema
     */
    coreLimit: number;
}

/**
 * Check if a given object implements the UpdateWorkspaceMembershipSchema interface.
 */
export function instanceOfUpdateWorkspaceMembershipSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isAdmin" in value;
    isInstance = isInstance && "creditLimit" in value;
    isInstance = isInstance && "coreLimit" in value;

    return isInstance;
}

export function UpdateWorkspaceMembershipSchemaFromJSON(json: any): UpdateWorkspaceMembershipSchema {
    return UpdateWorkspaceMembershipSchemaFromJSONTyped(json, false);
}

export function UpdateWorkspaceMembershipSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWorkspaceMembershipSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAdmin': json['is_admin'],
        'creditLimit': json['credit_limit'],
        'coreLimit': json['core_limit'],
    };
}

export function UpdateWorkspaceMembershipSchemaToJSON(value?: UpdateWorkspaceMembershipSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_admin': value.isAdmin,
        'credit_limit': value.creditLimit,
        'core_limit': value.coreLimit,
    };
}

